import { render, staticRenderFns } from "./AddInvoiceService.vue?vue&type=template&id=10e32087&"
import script from "./AddInvoiceService.vue?vue&type=script&lang=js&"
export * from "./AddInvoiceService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports